import React from "react";
import "rc-dropdown/assets/index.css"; // Import the default styles
import styles from "./notification.module.css"; // Import your CSS module
import NotificationDropdown from "common/RcDropDown";
import { useNavigate } from "react-router-dom";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import useAuthUser from 'react-auth-kit/hooks/useAuthUser';

const MyAccount = () => {
  const navigate = useNavigate();
  const signOut = useSignOut()
  
  const auth = useAuthUser();

  // Helper function to format name properly
  const formatName = () => {
    let firstName = auth?.first_name || '';
    let lastName = auth?.last_name || '';
    
    // Remove numbers from both names
    firstName = firstName.replace(/[0-9]/g, '').trim();
    lastName = lastName.replace(/[0-9]/g, '').trim();
    
    // If lastName is null, undefined, or empty, try to split firstName
    if (!lastName && firstName.includes(' ')) {
      const nameParts = firstName.split(' ').filter(part => part.trim());
      firstName = nameParts[0] || '';
      lastName = nameParts.slice(1).join(' ') || '';
    }
    
    // Build the display name
    const displayName = [firstName, lastName].filter(Boolean).join(' ');
    
    return displayName || 'User';
  };

  const myAccountFunc = () => {
    navigate("/my-account");
  };

  const logOutFunc = () => {
    signOut()
    navigate("/");

  };

  const myAccount = [
    { id: 1, label: "My Account", onClick: myAccountFunc },
    { id: 2, label: "Logout", onClick: logOutFunc },
  ];

  const menu = (
    <div className={styles.notificationDropdown}>
      {myAccount.length ? (
        myAccount.map((notification) => (
          <div
            key={notification.id}
            className={styles.notificationItem}
            onClick={notification?.onClick}
          >
            {notification.label}
          </div>
        ))
      ) : (
        <div className={styles.noNotifications}>No notifications</div>
      )}
    </div>
  );

  const Comp = (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <img src="/icons/user.svg" alt="user Image" />
        {/* <div className={styles.userName}>{auth?.first_name + " "+  auth?.last_name || ""}</div> */}
      <div className={styles.userName}>{formatName()}</div>
    </div>
  );

  return (
    <NotificationDropdown data={myAccount} childComp={Comp} renderFunc={menu} />
  );
};

export default MyAccount;

